export default class LogbuchEmail {
    /** PK: fw_logbuch_email | erforderlich **/
    public logbuch_email_seq: number | null = null;
    /** Absender | max. 200 Zeichen **/
    public absender: string | null = null;
    /** Header | max. -1 Zeichen **/
    public header: string | null = null;
    /** Empfaenger Email | max. 200 Zeichen **/
    public empfaenger_email: string | null = null;
    /** Betreff | max. 1000 Zeichen **/
    public betreff: string | null = null;
    /** Zeitpunkt **/
    public zeitpunkt: string | null = null;
    /** Text | max. -1 Zeichen **/
    public text: string | null = null;
    /** Debug | max. -1 Zeichen **/
    public debug: string | null = null;

    constructor(data?: Partial<LogbuchEmail>) {
        Object.assign(this, data);
    }
}
